import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';


@Injectable()
export class StudentService extends ServiceGlobal {
    student_id: number;
    code: string;
    school: any;
    form: any;
    class: any;
    class_number: number;
    first_name: string;
    last_name: string;
    display_name: string;
    full_name_zh: string;
    gender: any;
    mentee: any;
    academic_year_id: any;
    group_details: any;
    name_alpha: any = 'display_name';
    api_find_all: any = 'student_list';
    api_find_one: any = 'students';
    api_delete: any  = 'students';
    loading: any = false;
    primary_key: any = 'student_id';
    document_name: string;
    document_type: string = null;
    document: any;
    tableName() { return 'student'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "student_id": "Student",
            "code": "Code",
            "school": "School",
            "form": "Form",
            "class": "Class",
            "class_number": "Class number",
            "first_name": "First Name",
            "last_name": "Last Name",
            "display_name": "Display Name",
            "full_name_zh": "Chinese Name",
            "gender": "Gender",
            "mentee": "Mentee",
            "academic_year_id": "Year",
            "group_details": "Groups",
            "mentor": "Mentor",
            "primary_group": "Primary Group",
            "academic_year": "Academic Year",
            "document_name": "Document Name",
            "document_type": "Document Type",
            "document": ' ',
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "student_id": {
                "type": "string",
                "auto_increment": true,
                "primary_key": true,
            },
            "code": {
                "type": "string",
                "size": 255
            },
            "school": {
                "type": "string",
                "size": 11,
                "require" : {
                  "empty": true,
                }
            },
            "school_id": {
              'search': true
            },
            "form": {
                "type": "int",
                "require": {
                    "empty": true
                },
            },
            "class": {
                "type": "any",
                "require": {
                    "empty": true
                },
            },
            "class_number": {
                "type": "int",
                "require": {
                    "empty": true
                },
            },
            "first_name":  {
                "type": "any",
                "require": {
                    "empty": true
                },
            },
            "last_name":  {
                "type": "any",
                "require": {
                    "empty": true
                },
            },
            "display_name":  {
                "type":"any",
                'search': {
                    'op'    : 'like',
                    'value' : '%{value}%',
                }
            },
            "full_name_zh":  {
                "type":"any"
            },
            "gender": {
                "type":"any",
                "require" :{
                    "empty": true,
                }
            },
            "mentee":  {
                "type":"any",
                'search': true
            },
            "academic_year_id": {
                "type":"any"
            },
            "group_details": {
                "type": "any",
            },
            "mentor":{
                "type": "any"
            },
            "primary_group": {
                "type": "any"
            },
            "academic_year": {
                "type": "any",
                "require": {
                    "empty": true,
                },
                'search': true,
            },
            "filter_field": {
                "search": true,
            },
            "document": {
              "type": "any"
            },
            "document_name": {
              "type": "any",
              "require": {
                "correlateEmpty": {
                  "isDisplayRequired": true,
                  "correlateEqual": true,
                  "correlateItem": {value: "document", label: "Document"},
                  "correlateValue": [{value: '!undefined', label: 'Document'}]
                },
              },
            },
        });
    }

    save(update=false) {
        var link = API.CREATE_STUDENT;
        let attrs = this.getAttributes();

        let file = attrs['document'];
        if (file && attrs['mentee']) {
            let filename = attrs['document_name'];
            file.name = filename;
            attrs['student_files'] = [{
                file: file,
                type: attrs['document_type']
            }];
        } else {
            attrs['student_files'] = [];
        }

        delete attrs['document_type'];
        delete attrs['document_name'];
        delete attrs['document'];

        if(update) {
            //attrs = this.getAttributesUpdate();
            attrs['createddate'] = this.createddate;
            attrs['created_by'] = this.created_by;
            link += '/' + attrs['student_id'];
            if (file && file.url) {
                link += '?' +
                        encodeURIComponent('$expand') +
                        '=' +
                        encodeURIComponent('student_files/file');
            }
            return this._db.post(link, attrs);
        }
        return this._db.post(link, attrs);
    }

    exportStudent(condition: any = {}) {
      let api_request = API.API_URL_COMMON + "export_students";
      return this._db.getCsv(api_request, condition);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/student.service.ts